import { Store } from './store';
import { makeObservable, observable } from 'mobx';
import { BaseStore } from './baseStore';
import { useNavigate } from 'react-router';

export enum SessionStoreState {
  NOT_INITIALIZED = 1 << 0,
  CURRENT_SESSION = 1 << 1,
  SESSION_LIST = 1 << 2,
}

export class SessionStore extends BaseStore<SessionStoreState> {
  sessionInitialized: boolean;
  sessions: any[];
  activeSession: any;
  constructor(store: Store) {
    super(SessionStoreState.NOT_INITIALIZED, store, 'red');
    makeObservable(this, {
      sessionInitialized: observable,
      sessions: observable,
      activeSession: observable,
    });
    this.reload();
    this.log('Init SessionStore endpoint');
  }

  reload() {
    this.setState(SessionStoreState.NOT_INITIALIZED);
    this.sessionInitialized = false;
    this.sessions = [];
    this.activeSession = null;
    if (this.store.token != null) this.loadSessions();
  }

  setActiveSession(session: any) {
    if (session != null) {
      this.addState(SessionStoreState.CURRENT_SESSION);
    } else {
      this.removeState(SessionStoreState.CURRENT_SESSION);
    }
    this.log('Session is loaded');
    this.activeSession = session;
  }

  async loadSessions() {
    try {
      this.log('Loading sessions from API...');

      const response = await fetch(`${this.store!.apiURL}/auth/sessions`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${this.store!.token}`,
        },
      });

      if (response.status === 401) {
        this.log('Unauthorized while loading sessions; logging out');
        this.store!.logout();
        return;
      }

      if (!response.ok) {
        this.log('Failed to load sessions, status:', response.status);
        this.sessions = [];
        return;
      }

      const data = await response.json().catch(() => null);
      const raw = data?.data ?? data ?? [];
      const list = Array.isArray(raw) ? raw : [];

      this.sessions = list
        .slice()
        .sort(
          (a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
        );

      this.log('Loaded sessions:', this.sessions.length);
      this.addState(SessionStoreState.SESSION_LIST);
    } catch (error) {
      this.log('Error loading sessions:', error);
      this.sessions = [];
    }
  }

  isReady(): boolean {
    return (
      this.hasState(SessionStoreState.SESSION_LIST) &&
      this.hasState(SessionStoreState.CURRENT_SESSION)
    );
  }

  logout() {
    fetch(`${this.store!.apiURL}/auth/sessions`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${this.store!.token}`,
      },
    }).then(async response => {
      this.sessions = [];
      this.sessionInitialized = false;
      this.activeSession = null;
      this.setState(SessionStoreState.NOT_INITIALIZED);
    });
  }

  async logoutAllSessions(password: string): Promise<void> {
    try {
      const response = await fetch(`${this.store!.apiURL}/auth/sessions/all`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.store!.token}`,
        },
        body: JSON.stringify({ password }),
      });

      if (!response.ok) {
        const error = await response.text();
        throw new Error(`Logout failed: ${error}`);
      }

      this.store.logout();
    } catch (error) {
      this.log('❌ Błąd podczas wylogowywania wszystkich sesji:', error);
    }
  }
}
